import Vue from "vue";
import Prompt, {buttonType} from "@core/Components/Util/Prompt";

async function alertViaComponent(title, body){
  const el = document.createElement('div');
  document.body.appendChild(el);

  let vueInstance = null;

  const promptmise = new Promise((resolve) => {
    vueInstance = new Vue({
      el: el,
      render: function (createElement) {
        return createElement(Prompt, {
          props: {
            title: title,
            body: body,
            buttons: [buttonType.Ok]
          },
          on: {
            hidden: () => resolve()
          }
        });
      }
    });
  });

  await promptmise;

  //Always cleanup after we're done
  vueInstance.$destroy();
  el.remove();
}

export default alertViaComponent;